import { render, staticRenderFns, recyclableRender, components } from "./modify-real.vue?vue&type=template&id=3e43bc70&scoped=true&"
var renderjs
import script from "./modify-real.vue?vue&type=script&lang=js&"
export * from "./modify-real.vue?vue&type=script&lang=js&"
import style0 from "./modify-real.vue?vue&type=style&index=0&id=3e43bc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43bc70",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/modify-real/modify-real.vue"
export default component.exports